import toDate from '../to-date';

export const getProgress = (
  date: Date | number,
  interval: { start: Date | number; end: Date | number }
): number => {
  const time = toDate(date).getTime();
  const startTime = toDate(interval.start).getTime();
  const endTime = toDate(interval.end).getTime();

  const progress = Math.floor(((time - startTime) / (endTime - startTime)) * 100);

  return progress > 100 ? 100 : progress;
};

export default getProgress;
